import { render, staticRenderFns } from "./AddPhotos.vue?vue&type=template&id=76a9bba0&"
import script from "./AddPhotos.vue?vue&type=script&lang=js&"
export * from "./AddPhotos.vue?vue&type=script&lang=js&"
import style0 from "./AddPhotos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports